var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-tables',{ref:"childRef",attrs:{"tableConfig":_vm.tableConfig,"searchParams":_vm.searchData,"noCreatText":_vm.noCreatText,"ImgSrc":_vm.nullImg,"noSearchTerms":true},on:{"tableChange":_vm.handleTableHeaderChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }